<div class="mat-body-2 flex flex-col gap-3 p-4">
  {{ 'contact.info' | translate }}
  <div class="mt-8 flex items-baseline">
    <div class="flex flex-col">
      <span>{{ 'contact.phone' | translate }}:</span>
      <span>{{ 'contact.supportedLanguages' | translate }}:</span>
    </div>
    <div class="ml-4 flex flex-1 flex-col">
      <span>{{ phoneNumber }}</span>
      <span>{{ supportedLanguages }}</span>
    </div>
  </div>
</div>
